import { useEffect, useRef, useState } from "react";
import ViewHeadlineOutlinedIcon from "@mui/icons-material/ViewHeadlineOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useNavigate } from "react-router-dom";

const SubHeader = ({ text, toggleMobileMenu }) => {
  const [menu, setMenu] = useState(false);
  const menuContainerRef = useRef(null);
  const navigate = useNavigate();

  const user = localStorage.getItem("JainaUser");

  const handleLogout = () => {
    localStorage.removeItem("JainaAccessToken");
    localStorage.removeItem("JainaUser");
    localStorage.removeItem("webidInfo");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("fyearInfo");
    navigate("/");
  };

  // Close the menu when clicking/touching outside (mobile-friendly)
  useEffect(() => {
    const handleOutside = (e) => {
      if (
        menuContainerRef.current &&
        !menuContainerRef.current.contains(e.target)
      ) {
        setMenu(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("touchstart", handleOutside, { passive: true });
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
    };
  }, []);

  return (
    <div className="flex w-full items-center justify-between mb-4 py-2 pr-4 bg-primary shadow-custom-medium relative z-40">
      <div className="flex space-x-1 font-semibold font-mont text-fourth">
        <div className="" onClick={toggleMobileMenu}>
          <ViewHeadlineOutlinedIcon />
        </div>
        <p className="">{text}</p>
      </div>
      <div className="relative" ref={menuContainerRef}>
        <button
          type="button"
          onClick={() => setMenu((m) => !m)}
          aria-haspopup="menu"
          aria-expanded={menu}
          className="flex pl-4 space-x-1 items-center py-2 text-fourth font-bold font-mont text-sm hover:cursor-pointer"
        >
          <AccountCircleOutlinedIcon />
          <p>{user}</p>
          <ArrowDropDownIcon />
        </button>
        <div
          className={`${
            menu ? "absolute flex" : "hidden"
          } right-0 mt-1 bg-white border shadow-custom-medium rounded-sm w-max min-w-full text-primary z-50`}
        >
          <button
            className="w-full my-1 py-1 hover:bg-fourth"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubHeader;
